
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast as toastFunction } from "@/hooks/use-toast";

type UseCheckoutRedirectProps = {
  toast?: {
    success: (message: string) => void;
    error: (message: string) => void;
  };
};

export const useCheckoutRedirect = ({ toast }: UseCheckoutRedirectProps = {}) => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    // Checkout session redirect handling
    if (searchParams.get('success') === 'true') {
      if (toast?.success) {
        toast.success('Your subscription has been successfully created!');
      } else {
        toastFunction({
          title: "Success",
          description: 'Your subscription has been successfully created!',
        });
      }
    }
    
    if (searchParams.get('canceled') === 'true') {
      if (toast?.error) {
        toast.error('Subscription checkout was canceled.');
      } else {
        toastFunction({
          title: "Error",
          description: 'Subscription checkout was canceled.',
          variant: "destructive",
        });
      }
    }
    
    // Setup session redirect handling
    if (searchParams.get('setup_success') === 'true') {
      if (toast?.success) {
        toast.success('Your payment method has been successfully added!');
      } else {
        toastFunction({
          title: "Success",
          description: 'Your payment method has been successfully added!',
        });
      }
    }
    
    if (searchParams.get('setup_canceled') === 'true') {
      if (toast?.error) {
        toast.error('Payment method setup was canceled.');
      } else {
        toastFunction({
          title: "Error",
          description: 'Payment method setup was canceled.',
          variant: "destructive",
        });
      }
    }
  }, [searchParams, toast]);
};
